<template>
    <OrderForm
        v-model:form="form"
        v-model:files="files"
        :addresses="addresses"
        :quotResponse="quotResponse"
        :quotRequest="quotRequest"
        :error="error"
        @onSetAddres="setAddress"
        @submitForm="register"
    ></OrderForm>
</template>
<script>

import { useGoogleAnalytics } from "../../composables/useGoogleAnalytics";
import { useSwalFire } from "../../composables/useSwalFire";
import DropzoneUploader from "../../global-components/dropzone-uploader.vue";
import LengthInput from "../../global-components/LengthInput.vue";
import OrderForm from "../../global-components/orders/OrderFormComponent.vue";
import apiClient from "../../services/apiClient";

export default {
    name: 'order-form',
    components: {
        DropzoneUploader,
        LengthInput,
        OrderForm
    },
    setup () {
        const googleAnalytics = useGoogleAnalytics()
        const {trackPageView, trackFormFieldFocus, trackFormSubmission} = googleAnalytics
        return {trackPageView, trackFormFieldFocus, trackFormSubmission}
    },
    data() {
        return {
            form: {
                recipient_name: null,
                recipient_company: null,
                destination_address: {
                    line_1: '',
                    line_2: '',
                    line_3: '',
                    postal_code: '',
                    city: '',
                    state: ''
                },
                product_weight: '',
                product_width: '',
                product_length: '',
                product_height: '',
                product_cost: '',
                product_url: '',
                product_brand: '',
                international_tracking_number: '',
                product_description: '',
                add_address_book: false,
                add_insurance: false,
                chboxAgree: true,
                chboxAgree2: true,
                insurance: 0
            },
            files: [],
            quotResponse: {},
            quotRequest: {},
            error: [],
            formErrors: [],
            addresses: [],
            swalFire: null
        }
    },
    methods: {
        setQuotationInfo(){
            const request = this.normalizeRequest(this.quotRequest)
            this.quotRequest = request
            this.form.destination_address.postal_code = request.destination ?? ''
            this.form.product_height = this.roundUpDimension(request.height ?? 0)
            this.form.product_length = this.roundUpDimension(request.length ?? 0)
            this.form.product_weight = this.roundUpDimension(request.weight ?? 0)
            this.form.product_width = this.roundUpDimension(request.width ?? 0)
            this.form.product_cost = this.formatDecimal(request.cost ?? 0)
        },
        async register(payload) {
            this.trackFormSubmission('on_submit_order_form')
            try {
                const data = await apiClient.post('/api/order/create', payload, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                console.log(data)
                if (data.status === 401) {
                    location.href = '/';
                    throw new Error(response.statusText);
                }

                if(data.data.message == 'Order created.')
                    location.href = '/order/view';

                if(data.data.errors !== undefined) this.error = result.errors;
            } catch (error) {
                this.error = error;
            }
        },
        getAddressBook() {
            apiClient.get('/api/address_books')
            .then(response => {
                if (response.data.data) this.addresses = response.data.data
            })
            .catch((error) => {
                this.swalFire.onCatchError(error)
            });
        },
        setAddress(event) {
            const select = event.target;
            const option = select.options[select.selectedIndex];

            this.form.destination_address.line_1 = option.getAttribute('address_line_1');
            this.form.destination_address.line_2 = option.getAttribute('address_line_2');
            this.form.destination_address.line_3 = option.getAttribute('address_line_3');
            this.form.destination_address.city = option.getAttribute('city');
            this.form.destination_address.state = option.getAttribute('state');
        },
        insuranceFormat (insurance) {
            return Math.ceil(insurance * 100) / 100;
        },
        normalizeRequest(request) {
            if (!request) return {}
            const clone = JSON.parse(JSON.stringify(request))
            if (clone.originalValues && clone.originalUnitSystem !== undefined) {
                return {
                    ...clone,
                    cost: this.formatDecimal(clone.cost ?? 0),
                    height: this.roundUpDimension(clone.height ?? 0),
                    length: this.roundUpDimension(clone.length ?? 0),
                    weight: this.roundUpDimension(clone.weight ?? 0),
                    width: this.roundUpDimension(clone.width ?? 0),
                }
            }

            const unitSystem = clone.unitSystem || 'metric'
            const originalValues = JSON.parse(JSON.stringify(clone))
            const normalizeDimension = (value) => {
                if (value === null || value === undefined || value === '') return 0
                const numeric = Number(value)
                if (Number.isNaN(numeric)) return 0
                return numeric
            }

            let length = normalizeDimension(clone.length)
            let width = normalizeDimension(clone.width)
            let height = normalizeDimension(clone.height)
            let weight = normalizeDimension(clone.weight)

            if (unitSystem === 'imperial') {
                length = Number((length * 2.54).toFixed(2))
                width = Number((width * 2.54).toFixed(2))
                height = Number((height * 2.54).toFixed(2))
                weight = Number((weight * 0.45359237).toFixed(2))
            } else {
                length = Number(length.toFixed(2))
                width = Number(width.toFixed(2))
                height = Number(height.toFixed(2))
                weight = Number(weight.toFixed(2))
            }

            length = this.roundUpDimension(length)
            width = this.roundUpDimension(width)
            height = this.roundUpDimension(height)
            weight = this.roundUpDimension(weight)

            const cost = (() => {
                const numeric = Number(clone.cost)
                if (Number.isNaN(numeric)) return 0
                return Number(numeric.toFixed(2))
            })()

            return {
                ...clone,
                unitSystem,
                cost,
                length,
                width,
                height,
                weight,
                originalValues,
                originalUnitSystem: unitSystem
            }
        },
        formatDecimal (value) {
            const numeric = Number(value)
            if (Number.isNaN(numeric)) return value ?? 0
            return numeric % 1 === 0 ? numeric : Number(numeric.toFixed(2))
        },
        roundUpDimension (value) {
            const numeric = Number(value)
            if (Number.isNaN(numeric)) return 0
            return Math.ceil(numeric)
        }
    },
    mounted() {
        this.quotResponse = JSON.parse(sessionStorage.getItem('quotationResponse'));
        this.quotRequest = JSON.parse(sessionStorage.getItem('quotationRequest'));
        this.setQuotationInfo();
        this.getAddressBook();
        this.form.insurance = this.quotResponse.insurance ? this.insuranceFormat(this.quotResponse.insurance) : 0;
        this.swalFire = useSwalFire()
        this.trackPageView('ORDER_PAGE')
    }
}
</script>
